import React, { Fragment, useEffect, useMemo, useState, useCallback } from 'react'
import { Button, Dropdown, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, OverlayTrigger, Tooltip, Form, Row, Col } from 'react-bootstrap';

// Lazy Tooltip - рендерит тултип только при наведении мыши
const LazyTooltip: React.FC<{ text: string; children: React.ReactElement }> = ({ text, children }) => {
  const [show, setShow] = useState(false);

  return (
    <OverlayTrigger
      placement="top"
      show={show}
      onToggle={setShow}
      overlay={show ? <Tooltip>{text}</Tooltip> : <span />}
    >
      {children}
    </OverlayTrigger>
  );
};
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation } from '@np/np_webcomponentlib'
import { API_BUSINESS, API_OPERATIONS } from '../../shared/consts/api'

import { DataEntityType, columnsIdrfcharacteristictype, DisplayStatusDoc, optionsEnumStatusDoc, TypeStatusEnum, optionEnumTypeStatusEnum, getStatusString } from './OperationTypes'
import { TypePaymentMethodEnum, typePaymentMethodLabels } from '../../shared/MasterData/MasterDataTypes'

import { OperationForm } from './OperationForm'

import { ColumnEvent, ColumnWithCopyToClipboard } from '../../shared/entityOperations/EntityOperationsCustomFC'

import '../../shared/entityOperations/EntityOperations.css'
import { OperationFormAmount } from './OperationFormAmount';
import { useNavigate } from 'react-router-dom';

import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import DHInterationList from '../DHInteraction/DHInterationList';

function formatToMoscowTime(date: Date | string): string {
  const moscowTimeZone = 'Europe/Moscow';
  const zonedDate = toZonedTime(new Date(date), moscowTimeZone);
  return format(zonedDate, 'yyyy-MM-dd HH:mm:ss');
}


const DocClientList = ({ listFilterFieldProps, title }: { listFilterFieldProps: ListFields[], title: string }) => {

  const navigate = useNavigate()

  const [idEdit, setIDEdit] = useState<string>("")

  const [idEditAmount, setIDEditAmount] = useState<string>("")

  const [idDetails, setIDDetails] = useState<string>("")

  const [forceUpdate, setForceUpdate] = useState<boolean>(false)

  const [show2, setShow2] = useState(false);
  const xtralargemodalClose = () => { setIDEdit(""); setShow2(false) };
  const xtralargemodalShow = () => setShow2(true);

  const [showAmount, setShowAmount] = useState(false);
  const xtralargemodalCloseAmount = () => { setIDEditAmount(""); setShowAmount(false) };
  const xtralargemodalShowAmount = () => setShowAmount(true);

  const [showDetails, setShowDetails] = useState(false);
  const xtralargemodalCloseDetails = () => { setIDDetails(""); setShowDetails(false) };
  const xtralargemodalShowDetails = () => setShowDetails(true);

  const [showDateRange, setShowDateRange] = useState(false);
  const [dateFrom, setDateFrom] = useState<string>('');
  const [dateTo, setDateTo] = useState<string>('');
  const [selectedStatuses, setSelectedStatuses] = useState<TypeStatusEnum[]>([]);
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState<TypePaymentMethodEnum[]>([]);
  const [amountFrom, setAmountFrom] = useState<string>('');
  const [amountTo, setAmountTo] = useState<string>('');

  // Авто-обновление
  const [autoRefreshInterval, setAutoRefreshInterval] = useState<number>(0); // 0 = выключено, иначе секунды

  const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('SpecificationcharacteristictypeList');

  const statusLabelMap: Record<string, string> = {
    created: 'Создана',
    in_progress: 'В обработке',
    success: 'Успешно',
    failed: 'С ошибкой',
    precreated: 'Предсоздана',
    booking: 'Бронирование',
    pending_retry: 'Ожидает retry'
  };

  const availableStatuses = optionsEnumStatusDoc.filter(option => option.value !== undefined && option.value !== null) as optionEnumTypeStatusEnum[];

  const toggleStatus = (value: TypeStatusEnum) => {
    setSelectedStatuses(prev =>
      prev.includes(value)
        ? prev.filter(status => status !== value)
        : [...prev, value]
    );
  };

  const togglePaymentMethod = (value: TypePaymentMethodEnum) => {
    setSelectedPaymentMethods(prev =>
      prev.includes(value)
        ? prev.filter(method => method !== value)
        : [...prev, value]
    );
  };

  const statusButtonTitle = selectedStatuses.length > 0
    ? selectedStatuses.map(status => statusLabelMap[TypeStatusEnum[status]] ?? TypeStatusEnum[status]).join(', ')
    : 'Статусы';

  const paymentMethodButtonTitle = selectedPaymentMethods.length > 0
    ? selectedPaymentMethods.map(method => typePaymentMethodLabels[method] ?? method).join(', ')
    : 'Метод платежа';

  const initialFilter: FilterState = useMemo(() => {
    const filterFields = [...listFilterFieldProps];
    
    if (dateFrom) {
      // Преобразуем формат datetime-local в ISO формат для бэкенда
      const dateFromISO = dateFrom ? new Date(dateFrom).toISOString() : '';
      filterFields.push({
        fieldName: 'dateAdded',
        comparison: 'dateTimeMoreEqual',
        listVal: [dateFromISO],
      });
    }
    
    if (dateTo) {
      // Преобразуем формат datetime-local в ISO формат для бэкенда
      const dateToISO = dateTo ? new Date(dateTo).toISOString() : '';
      filterFields.push({
        fieldName: 'dateAdded',
        comparison: 'dateTimeLessEqual',
        listVal: [dateToISO],
      });
    }
    
    if (selectedStatuses.length > 0) {
      filterFields.push({
        fieldName: 'status',
        comparison: 'equalsStrong',
        listVal: selectedStatuses
          .map(status => TypeStatusEnum[status])
          .filter(Boolean) as string[],
      });
    }

    if (selectedPaymentMethods.length > 0) {
      filterFields.push({
        fieldName: 'paymentMethod',
        comparison: 'equalsStrong',
        listVal: selectedPaymentMethods as string[],
      });
    }

    if (amountFrom) {
      filterFields.push({
        fieldName: 'amount',
        comparison: 'numberMoreEqual',
        listVal: [amountFrom],
      });
    }

    if (amountTo) {
      filterFields.push({
        fieldName: 'amount',
        comparison: 'numberLessEqual',
        listVal: [amountTo],
      });
    }

    return {
      listFields: filterFields,
      sort: null,
      searchData: '',
      take: 25,
      skip: 0,
    };
  }, [listFilterFieldProps, dateFrom, dateTo, selectedStatuses, selectedPaymentMethods, amountFrom, amountTo]);



  const dateAddedTitle = useTranslation('dateAdded');


  function truncateStringInMiddle(str: string): string {
    const maxLength = 39; // Длина GUID + 3 символа

    if (str.length <= maxLength) {
      return str;
    }

    // Рассчитываем количество символов, которые будут оставлены слева и справа от "..."
    const charsToShow = Math.floor((maxLength - 3) / 2);
    const leftPart = str.slice(0, charsToShow);
    const rightPart = str.slice(-charsToShow);

    return `${leftPart}...${rightPart}`;
  }


  const memoizedColumns = useMemo(() => {
    const columnsSpecificationcharacteristictype: Column[] = [

      //   {
      //     title: 'ID Платформы/ID Мерчанта',
      //     listFields: null,
      //     type: 'custom',
      //     custom: (data: DataEntityType) => (
      //       <>
      //       <table style={{ width: '100%', textAlign: 'left' }}>
      //   <tbody>
      //     <tr>
      //       <td>
      //         <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcon' />
      //       </td>
      //       <td>{data.idUnique}</td>
      //     </tr>
      //     <tr>
      //       <td>
      //         <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcon' />
      //       </td>
      //       <td>{data.idTransactionMerchant}</td>
      //     </tr>
      //   </tbody>
      // </table>
      //       </>
      //     ),
      //     key: 1,
      //     withFilter: null
      //   },

      {
        title: 'Наш ID',
        listFields: {
          fieldName: 'idUnique',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <>
            <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
            {data.idUnique}
          </>
        ),
        key: 51,
        withFilter: 'all',
        class: "eventColumn"
      },

      {
        title: "Мерчант",
        listFields: {
          fieldName: 'idBusiness',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <div onClick={() => navigate("/business/" + data.idBusiness)}>
            {data.businessAsProduct?.name}
          </div>
        ),
        key: 8,
        withFilter: 'choose',

        filterChooseProps: {
          getDisplayDescription: (selectedData: any) => {
            return selectedData ? selectedData.name : ''
          },
          apiUrl: `${API_BUSINESS}business/list`,
          columns: columnsIdrfcharacteristictype,
          children: 'Поиск...',
          initialFilterState: {
            listFields: [{ fieldName: "typeBusiness", comparison: "equalsStrong", listVal: ["merchant"] }],
            sort: null,
            searchData: '',
            take: 50,
            skip: 0,
          },
        },
      },


      {
        title: 'ID мерчанта',
        listFields: {
          fieldName: 'idTransactionMerchant',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <>
            <ColumnWithCopyToClipboard data={data.idTransactionMerchant} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
            {truncateStringInMiddle(data.idTransactionMerchant)}
          </>
        ),
        key: 52,
        withFilter: 'all',
        class: "eventColumn"
      },



      //         {
      //     title: "ID Мерчанта",
      //     listFields: {
      //         fieldName: 'idTransactionMerchant',
      //         comparison: 'containsIgnoreCase',
      //         listVal: [''],
      //     },
      //     key: 7,
      //     withFilter: 'all',
      // },




      {
        title: dateAddedTitle,
        listFields: {
          fieldName: 'dateAdded',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <>
            <div>{data.dateAdded ? formatToMoscowTime(data.dateAdded) : 'N/A'}</div>
            <div>{data.dateFinalCalculation ? formatToMoscowTime(data.dateFinalCalculation) : 'N/A'}</div>
          </>
        ),
        key: 100,
        withFilter: null,
        class: "dateTtimeColumn"
      },


      // {
      //   title: dateAddedTitle,
      //   listFields: {
      //     fieldName: 'dateAdded',
      //     comparison: 'containsStrong',
      //     listVal: [''],
      //   },
      //   type: 'date-time',
      //   key: 100,
      //   withFilter: 'onlySorted',
      //   class: "dateTtimeColumn"
      // },

      // {
      //   title: "Дата обработки",
      //   listFields: {
      //     fieldName: 'dateFinalCalculation',
      //     comparison: 'containsStrong',
      //     listVal: [''],
      //   },
      //   type: 'date-time',
      //   key: 110,
      //   withFilter: 'onlySorted',
      //   class: "dateTtimeColumn"
      // },


      {
        title: "Метод",
        listFields: {
          fieldName: 'paymentMethod',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        key: 210,
        withFilter: null
      },


      {
        title: '',
        listFields: {
          fieldName: '_actions',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (


          <>
            <LazyTooltip text="Статус">
              <ColumnEvent idUnique={data.idUnique} event={handleEdit} title='fe fe-edit eventIcom' />
            </LazyTooltip>
            <LazyTooltip text="Сумма">
              <ColumnEvent idUnique={data.idUnique} event={handleEditAmount} title='fe fe-dollar-sign eventIcom' />
            </LazyTooltip>
            <LazyTooltip text="Вебхук">
              <ColumnEvent idUnique={data.idUnique} event={handleSendWebHook} title='fe fe-send eventIcom' />
            </LazyTooltip>
            <LazyTooltip text="Детали">
              <ColumnEvent idUnique={data.idUnique} event={handleDetails} title='fe fe-shuffle eventIcom' />
            </LazyTooltip>
            {/* Кнопки retry/cancel для payout в статусе pending_retry или failed */}
            {data.typeOperation === 'payOut' && (getStatusString(data.status) === 'pending_retry' || getStatusString(data.status) === 'failed') && (
              <>
                {!(data.basis && data.basis.includes('|MANUAL_CANCEL|')) && (
                  <LazyTooltip text="Retry Payout">
                    <ColumnEvent idUnique={data.idUnique} event={handleRetryPayout} title='fe fe-refresh-cw eventIcom' />
                  </LazyTooltip>
                )}
                <LazyTooltip text="Отменить Payout">
                  <ColumnEvent idUnique={data.idUnique} event={handleCancelPayout} title='fe fe-x-circle eventIcom' />
                </LazyTooltip>
              </>
            )}
          </>


          //<ColumnEvent idUnique={data.idUnique} event={handleEdit} title='fe fe-edit eventIcom'></ColumnEvent>
        ),
        key: 2,
        withFilter: null,
        class: "eventColumn"
      },

      {
        title: "Статус",
        listFields: {
          fieldName: 'status',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        key: 7,
        type: 'custom',
        custom: (data: DataEntityType) => <><DisplayStatusDoc statusDoc={data.status} providerID={data.idProvider}></DisplayStatusDoc></>,
        withFilter: null,
      },

      {
        title: "Сумма",
        listFields: {
          fieldName: 'amount',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => <><h4>{data?.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</h4>
        <div style={{ fontSize: '0.85em' }}>{data?.amountInitial.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</div>
        <div style={{ fontSize: '0.85em' }}>{data?.amountRandomized.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</div>
        </>,
        key: 71,
        withFilter: null,
      },

      {
        title: "Сумма в вал. баланса/курс/курс мерчанта/кр",
        listFields: {
          fieldName: 'amountInCurrencyBalance',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => {
          const isPink = false;//Number(data?.exchangeRate) > Number(data?.exchangeRateForMerchant);
          return (
            <div style={isPink ? { background: '#ffc0cb' } : {}}>
              <div>
                {data?.amountInCurrencyBalance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}/{data?.exchangeRate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
              </div>
              <div>
                {data?.exchangeRateForMerchant.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
              </div>

               <div>
                {data?.exchangeRateDifference.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
              </div>
            </div>
          );
        },
        key: 75,
        withFilter: null,
      },

      {
        title: "Провайдер/Курс",
        listFields: {
          fieldName: 'idProvider',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <>
          <div onClick={() => navigate("/business/" + data.idProvider)}>
            {data.businessAsProvider?.name}
          </div>
          <div>
            {data?.exchangeRateForProvider.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
          </div>
          </>
        ),


        //custom: (data: DataEntityType) => <>{data.businessAsProvider?.name}</>,
        key: 18,



        withFilter: 'choose',

        filterChooseProps: {
          getDisplayDescription: (selectedData: any) => {
            return selectedData ? selectedData.name : ''
          },
          apiUrl: `${API_BUSINESS}business/list`,
          columns: columnsIdrfcharacteristictype,
          children: 'Поиск...',
          initialFilterState: {
            listFields: [{ fieldName: "typeBusiness", comparison: "equalsStrong", listVal: ["provider"] }],
            sort: null,
            searchData: '',
            take: 50,
            skip: 0,
          },
        },
      },

      {
        title: 'ID провайдера',
        listFields: {
          fieldName: 'idTansactionProvider',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <>
            <ColumnWithCopyToClipboard data={data.idTansactionProvider !== undefined ? data.idTansactionProvider : ""} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
            {data.idTansactionProvider}
          </>
        ),
        key: 54,
        withFilter: 'all',
        class: "eventColumn"
      },

      {
        title: 'Реквизиты',
        listFields: {
          fieldName: 'number',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <>
            <div>{data.number}</div>
            <div>{data.nameMediator}</div>
            <div>{data.numberAdditional}</div>
            <div>{data.bankName}</div>
          </>
        ),
        key: 53,
        withFilter: 'all',
        class: "eventColumn"
      },

      {
        title: 'ClientID',
        listFields: {
          fieldName: 'clientID',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'custom',
        custom: (data: DataEntityType) => (
          <>
            <ColumnWithCopyToClipboard data={data.clientID ?? ''} title='fe fe-edit eventIcom' />
            {truncateStringInMiddle(data.clientID ?? '')}
          </>
        ),
        key: 55,
        withFilter: 'all',
        class: "eventColumn"
      },






      //   {
      //     title: "Содержание",
      //     listFields: {
      //         fieldName: 'viewData',
      //         comparison: 'containsIgnoreCase',
      //         listVal: [''],
      //     },
      //     key: 7,
      //     withFilter: 'all',
      // },

      //   {
      //     title: "Данные документа",
      //     listFields: {
      //         fieldName: 'valueAsJSON',
      //         comparison: 'containsIgnoreCase',
      //         listVal: [''],
      //     },
      //     key: 7,
      //     type: 'custom',
      //         custom: (data: DataEntityType) => <><DataDisplay data={JSON.parse(data.valueAsJSON)}></DataDisplay></>,
      //     withFilter: 'all',
      // },


      // {
      //   title: 'Тип документа',
      //   listFields: {
      //     fieldName: 'catalogCategory',
      //     comparison: 'equalsStrong',
      //     listVal: [''],
      //   },
      //   key: 7,
      //   type: 'custom',
      //   custom: (data: DataEntityTypeViewModel) => <>{data.characteristicType?.name}</>,

      //   withFilter: 'choose',

      //   filterChooseProps: {
      //     getDisplayDescription: (selectedData: any) => {
      //       return selectedData ? selectedData.name : ''
      //     },
      //     apiUrl: `${API_DOCUMENTS}/characteristic/type/list`,
      //     columns: columnsIdrfcharacteristictype,
      //     children: 'Поиск...',
      //   },
      // },





      // {
      //   title: dateUpdatedTitle,
      //   listFields: {
      //     fieldName: 'dateUpdated',
      //     comparison: 'containsStrong',
      //     listVal: [''],
      //   },
      //   type: 'date-time',
      //   key: 101,
      //   withFilter: 'onlySorted',
      //   class: "dateTtimeColumn"
      // }
    ]


    // if (debugMode || canRemove) {
    //   columnsSpecificationcharacteristictype.push(
    //     {
    //       title: '',
    //       listFields: null,
    //       type: 'custom',
    //       custom: (data: DataEntityType) => (

    //         <DeleteEntity idUnique={data.idUnique} apiPath={`${API_PRODUCT}/catalogproduct`} onResult={onResultRemove}></DeleteEntity>
    //       ),
    //       key: 102,
    //       withFilter: null,
    //       class: "eventColumn"
    //     })
    // }
    return columnsSpecificationcharacteristictype
  }, [dateAddedTitle, navigate])


  const handleEdit = (idUnigue: string) => {
    setIDEdit(idUnigue)
  }

  const handleEditAmount = (idUnigue: string) => {
    setIDEditAmount(idUnigue)
  }

  const handleDetails = (idUnigue: string) => {
    setIDDetails(idUnigue)
  }

  const handleSendWebHook = async (idUnigue: string) => {
    try {
      const token = localStorage.getItem('accessToken');
      await fetch(`${API_OPERATIONS}operation/h2h/handwh/${idUnigue}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        }
      });
    } catch (error) {
      console.error('Error sending webhook:', error);
    }
  }

  // Retry payout операции
  const handleRetryPayout = async (idUnigue: string) => {
    if (!window.confirm('Отправить payout на повторную обработку?')) return;
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${API_OPERATIONS}operation/payout/${idUnigue}/retry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        }
      });
      if (response.ok) {
        setForceUpdate(true);
        alert('Payout отправлен на retry');
      } else {
        alert('Ошибка при retry');
      }
    } catch (error) {
      console.error('Error retry payout:', error);
      alert('Ошибка при retry');
    }
  }

  // Отменить payout операцию
  const handleCancelPayout = async (idUnigue: string) => {
    const reason = window.prompt('Введите причину отмены:');
    if (!reason) return;
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${API_OPERATIONS}operation/payout/${idUnigue}/cancel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify({ reason })
      });
      if (response.ok) {
        setForceUpdate(true);
        alert('Payout отменён');
      } else {
        alert('Ошибка при отмене');
      }
    } catch (error) {
      console.error('Error cancel payout:', error);
      alert('Ошибка при отмене');
    }
  }


  const onResultRemove = (result: ResultOperation) => {
    if (result.status === "success") {

      setForceUpdate(true)

      console.log("forceUpdate:", forceUpdate)
    }
  }

  useEffect(() => {
    if (forceUpdate) {
      setForceUpdate(false)
    }
  }, [forceUpdate])

  // Авто-обновление таблицы
  useEffect(() => {
    if (autoRefreshInterval === 0) return;

    const intervalId = setInterval(() => {
      setForceUpdate(true);
    }, autoRefreshInterval * 1000);

    return () => clearInterval(intervalId);
  }, [autoRefreshInterval])

  const handleManualRefresh = useCallback(() => {
    setForceUpdate(true);
  }, []);


  useEffect(() => {
    if (idEdit !== "") {
      xtralargemodalShow()
    }
  }, [idEdit])

  useEffect(() => {
    if (idEditAmount !== "") {
      xtralargemodalShowAmount()
    }
  }, [idEditAmount])


  useEffect(() => {
    if (idDetails !== "") {
      xtralargemodalShowDetails()
    }
  }, [idDetails])



  const getTitleModal = () => {
    if (idEdit === "")
      return "Создание"
    else
      return "Редактирование"
  }



  const statusEditForm = useMemo(() => (
    <OperationForm
      title={getTitleModal()}
      idInit={idEdit}
      handleClose={xtralargemodalClose}
      initEntityProps={undefined}
    />
  ), [show2]);


  const amountEditForm = useMemo(() => (
    <OperationFormAmount
      title={getTitleModal()}
      idInit={idEditAmount}
      handleClose={xtralargemodalCloseAmount}
      initEntityProps={undefined}

    />
  ), [showAmount]);


  const detailsList = useMemo(() => (
    <DHInterationList
      listFilterFieldProps={[{fieldName: "iddhOperation", comparison: "equalsStrong", listVal: [idDetails]}]}
    />
  ), [showDetails]);

  return (
    <Fragment>

      <h2>{title}</h2>

      <div className="operation-table-wrapper mb-3">
        <div className="operation-table-filters">
          <Button
            variant="outline-success"
            size="sm"
            onClick={handleManualRefresh}
            title="Обновить"
          >
            <i className="fe fe-refresh-cw"></i>
          </Button>

          <Dropdown className="d-inline-block">
            <Dropdown.Toggle
              variant={autoRefreshInterval > 0 ? "success" : "outline-secondary"}
              size="sm"
              id="auto-refresh-toggle"
            >
              <i className="fe fe-clock me-1"></i>
              {autoRefreshInterval === 0 ? 'Авто' : `${autoRefreshInterval}с`}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                active={autoRefreshInterval === 0}
                onClick={() => setAutoRefreshInterval(0)}
              >
                Выкл
              </Dropdown.Item>
              <Dropdown.Item
                active={autoRefreshInterval === 5}
                onClick={() => setAutoRefreshInterval(5)}
              >
                5 сек
              </Dropdown.Item>
              <Dropdown.Item
                active={autoRefreshInterval === 10}
                onClick={() => setAutoRefreshInterval(10)}
              >
                10 сек
              </Dropdown.Item>
              <Dropdown.Item
                active={autoRefreshInterval === 15}
                onClick={() => setAutoRefreshInterval(15)}
              >
                15 сек
              </Dropdown.Item>
              <Dropdown.Item
                active={autoRefreshInterval === 30}
                onClick={() => setAutoRefreshInterval(30)}
              >
                30 сек
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setShowDateRange(true)}
          >
            <i className="fe fe-calendar me-1"></i>
            {dateFrom && dateTo
              ? `${new Date(dateFrom).toLocaleDateString('ru-RU')} - ${new Date(dateTo).toLocaleDateString('ru-RU')}`
              : 'Диапазон дат...'}
          </Button>

          <Dropdown className="d-inline-block">
            <Dropdown.Toggle variant="outline-secondary" size="sm" id="status-filter-toggle">
              {statusButtonTitle}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minWidth: '220px' }}>
              {availableStatuses.map(option => {
                const value = option.value!;
                return (
                  <Dropdown.Item as="label" key={value} className="d-flex align-items-center">
                    <Form.Check
                      type="checkbox"
                      id={`status-${value}`}
                      label={option.label}
                      checked={selectedStatuses.includes(value)}
                      onChange={() => toggleStatus(value)}
                    />
                  </Dropdown.Item>
                );
              })}
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => setSelectedStatuses([])}>
                Сбросить
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown className="d-inline-block">
            <Dropdown.Toggle variant="outline-secondary" size="sm" id="payment-method-filter-toggle">
              {paymentMethodButtonTitle}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minWidth: '220px', maxHeight: '300px', overflowY: 'auto' }}>
              {Object.values(TypePaymentMethodEnum).map(method => (
                <Dropdown.Item as="label" key={method} className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    id={`payment-method-${method}`}
                    label={typePaymentMethodLabels[method] ?? method}
                    checked={selectedPaymentMethods.includes(method)}
                    onChange={() => togglePaymentMethod(method)}
                  />
                </Dropdown.Item>
              ))}
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => setSelectedPaymentMethods([])}>
                Сбросить
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown className="d-inline-block">
            <Dropdown.Toggle variant="outline-secondary" size="sm" id="amount-filter-toggle">
              {amountFrom || amountTo
                ? `${amountFrom || '0'} - ${amountTo || '∞'}`
                : 'Сумма'}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minWidth: '250px', padding: '10px' }}>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">От</Form.Label>
                <Form.Control
                  type="number"
                  size="sm"
                  placeholder="Мин. сумма"
                  value={amountFrom}
                  onChange={(e) => setAmountFrom(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">До</Form.Label>
                <Form.Control
                  type="number"
                  size="sm"
                  placeholder="Макс. сумма"
                  value={amountTo}
                  onChange={(e) => setAmountTo(e.target.value)}
                />
              </Form.Group>
              <Button
                variant="outline-secondary"
                size="sm"
                className="w-100"
                onClick={() => { setAmountFrom(''); setAmountTo(''); }}
              >
                Сбросить
              </Button>
            </Dropdown.Menu>
          </Dropdown>

          {selectedStatuses.length > 0 && (
            <div className="status-summary">
              Статусы: {selectedStatuses.map(status => statusLabelMap[TypeStatusEnum[status]] ?? TypeStatusEnum[status]).join(', ')}
            </div>
          )}

          {selectedPaymentMethods.length > 0 && (
            <div className="status-summary">
              Методы: {selectedPaymentMethods.map(method => typePaymentMethodLabels[method] ?? method).join(', ')}
            </div>
          )}
        </div>

        <SelfTableList
          apiUrl={`${API_OPERATIONS}operation/list`}
          columns={memoizedColumns}
          classProp='table table-striped'
          theadClassProp='table'
          forceUpdate={forceUpdate}
          initialFilterState={initialFilter}
          key={`table-${dateFrom}-${dateTo}-${selectedStatuses.join(',')}-${selectedPaymentMethods.join(',')}-${amountFrom}-${amountTo}`}
        />
      </div>

      {/* {canCreate &&
        <Button variant="primary" onClick={xtralargemodalShow}><i className='fa fa-plus'></i>
        </Button>
      } */}

      <Modal size="xl" show={show2} onHide={xtralargemodalClose}>
        <ModalHeader>
          <ModalTitle as="h5"></ModalTitle>
          <span className="d-flex ms-auto" onClick={xtralargemodalClose}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          {statusEditForm}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={xtralargemodalClose}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>


      <Modal size="xl" show={showAmount} onHide={xtralargemodalCloseAmount}>
        <ModalHeader>
          <ModalTitle as="h5">Сумма</ModalTitle>
          <span className="d-flex ms-auto" onClick={xtralargemodalCloseAmount}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          {amountEditForm}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={xtralargemodalCloseAmount}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" show={showDetails} onHide={xtralargemodalCloseDetails}>
        <ModalHeader>
          <ModalTitle as="h5">Детали</ModalTitle>
          <span className="d-flex ms-auto" onClick={xtralargemodalCloseDetails}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          {detailsList}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={xtralargemodalCloseDetails}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>

      <Modal show={showDateRange} onHide={() => setShowDateRange(false)}>
        <ModalHeader>
          <ModalTitle as="h5">Выбор диапазона дат</ModalTitle>
          <span className="d-flex ms-auto" onClick={() => setShowDateRange(false)}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row className="mb-3">
              <Col>
                <Form.Label>Дата от (включительно)</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  step="1"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Label>Дата до (включительно)</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  step="1"
                />
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={() => {
            setDateFrom('');
            setDateTo('');
            setShowDateRange(false);
            setForceUpdate(true);
          }}>
            Сбросить
          </Button>
          <Button variant="primary" onClick={() => {
            setShowDateRange(false);
            setForceUpdate(true);
          }}>
            Применить
          </Button>
        </ModalFooter>
      </Modal>

    </Fragment>
  )
}


export default DocClientList
